import { useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../config/supabase';
import { useT } from '../hooks/useT';
import Button from '../components/common/Button';
import Input from '../components/common/Input';
import PublicNav from '../components/layout/PublicNav';

export default function ForgotPasswordPage() {
  const t = useT();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const redirectTo = `${window.location.origin}/reset-password`;
      const { error: err } = await supabase.auth.resetPasswordForEmail(email, { redirectTo });
      if (err) throw err;
      setSent(true);
    } catch (err) {
      setError(err.message || t('forgot.error'));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-surface">
      <PublicNav hideAuth />
      <div className="flex items-center justify-center p-4 py-12">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold text-slate-100">{t('forgot.title')}</h1>
          <p className="text-slate-400 mt-1">{t('forgot.subtitle')}</p>
        </div>

        {sent ? (
          <div className="card text-center space-y-4">
            <div className="text-4xl">📣</div>
            <p className="text-slate-200 font-medium">{t('forgot.success')}</p>
            <p className="text-slate-400 text-sm">{t('forgot.success_sub')}</p>
            <Link to="/login" className="block text-brand-400 hover:text-brand-300 text-sm transition-colors mt-2">
              ← {t('forgot.back_login')}
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="card space-y-4">
            <Input
              label={t('forgot.email')}
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => { setEmail(e.target.value); setError(''); }}
              required
              autoFocus
            />

            {error && (
              <div className="p-3 bg-red-900/20 border border-red-800 rounded-xl text-red-400 text-sm">
                {error}
              </div>
            )}

            <Button type="submit" className="w-full" isLoading={loading}>
              {t('forgot.submit')}
            </Button>

            <p className="text-center text-sm text-slate-500">
              <Link to="/login" className="text-brand-400 hover:text-brand-300 transition-colors">
                ← {t('forgot.back_login')}
              </Link>
            </p>
          </form>
        )}
      </div>
      </div>
    </div>
  );
}
